export class SIQEmptyViewTheme {
  backgroundColor = "null";
  chatButtonBackgroundColor = "null";
  chatButtonTitleColor = "null";
  textColor = "null";
}
//# sourceMappingURL=SIQEmptyViewTheme.js.map